// 接口签名 https://www.tapd.cn/22586881/prong/stories/view/1122586881001044391
/* eslint-disable camelcase */
import apiSignList from './apiSignList';

const md5 = require('md5');

const lm_s_id = 'LM6000101139961122666757'; // id
let lm_s_key;
if (window.ISONLINE || window.ISONLINE === undefined) {
  lm_s_key = atob('ZGQ0NmRiYjQ0MmI2ZTRiYTgxN2Q2MzQ3ZDJkZGY0OTM='); // 线上私钥
} else {
  lm_s_key = atob('MDFhMTNiMWU1MzZhNWJjYTc4ZTVhNDIxMjI1ZDA2Y2U='); // 测试私钥
}

/** 表单容器必须原样保留，避免签名合并丢失上传文件或表单字段。 */
const isFormBody = data => ['[object FormData]', '[object URLSearchParams]'].includes(Object.prototype.toString.call(data));

/** 识别 JSON 字符串 body，其他字符串沿用原有表单签名规则。 */
const readJsonBody = (data) => {
  try {
    const value = typeof data === 'string' && data.trim().charAt(0) === '{' ? JSON.parse(data) : null;
    return value && Object.prototype.toString.call(value) === '[object Object]' ? value : null;
  } catch (error) {
    return null;
  }
};

// 参与签名的参数
export const getSignParams = (requiredParams, config) => {
  // 将参数值为undefined的参数过滤出去，因为它们会参与签名，但实际请求中却没有。
  if (config.params) {
    const params = {};
    Object.keys(config.params).forEach((key) => {
      if (config.params[key] !== undefined && config.params[key] !== null) {
        params[key] = config.params[key];
      }
    });
    config.params = params;
  }
  let signParams = {};
  const method = config.method.toLowerCase();
  if (method === 'get') {
    // 合并必传参数
    config.params = Object.assign({}, requiredParams, config.params || {});
  } else if (method === 'post') {
    // 合并必传参数
    const jsonBody = readJsonBody(config.data);
    if (isFormBody(config.data)) {
      Object.keys(requiredParams).forEach(key => config.data.set(key, String(requiredParams[key])));
      config.data.forEach((value, key) => {
        if (typeof value === 'string') {
          signParams[key] = value;
        }
      });
    } else if (jsonBody) {
      signParams = Object.assign({}, requiredParams, jsonBody);
      config.data = JSON.stringify(signParams);
    } else if (typeof config.data === 'string') {
      let splitArr;
      config.data.split('&').forEach((item) => {
        splitArr = item.split('=');
        // eslint-disable-next-line prefer-destructuring
        signParams[splitArr[0]] = splitArr[1];
      });
      signParams = Object.assign({}, requiredParams, signParams);
      config.data = Object.keys(signParams).map(key => `${key}=${signParams[key]}`).join('&');
    } else {
      // 合并签名参数
      signParams = Object.assign(signParams, requiredParams, config.data || {});
      config.data = signParams;
    }
  }

  // 合并query参数
  signParams = Object.assign({}, config.params, signParams);

  return signParams;
};

// 将业务代码中transformRequest处理完的数据最后一位&去除，防止签名验证失败
export const transformRequest = (data) => {
  if (typeof data === 'string' && data.charAt(data.length - 1) === '&') {
    return data.slice(0, -1);
  }
  return data;
};

// 请求签名
export const requestSign = (signParams) => {
  // 按参数key升序排序,key+vlaue拼接,object类型的转为json,array用,拼接
  let sKey = Object.keys(signParams).sort().map((key) => {
    function getValue(val) {
      if (Array.isArray(val)) {
        return val.join(',');
      }
      if (typeof val === 'object') {
        return JSON.stringify(val);
      }
      return val;
    }
    return key + getValue(signParams[key]);
  }).join('');
  // 务必按顺序拼接
  sKey += lm_s_id + signParams.lm_s_ts + lm_s_key;
  console.log(sKey);

  return md5(sKey);
};

const needApiSign = (path) => {
  // 先匹配path
  // let flag = apiSignList.path.some(value => path.toLowerCase().includes(value.toLowerCase()));
  let flag = apiSignList.path.some(value => value.toLowerCase() == path.toLowerCase());
  if (!flag) { // path匹配不到，再匹配正则（忽略大小写）
    flag = apiSignList.reg.some(pattern => new RegExp(pattern, 'i').test(path));
  }
  return flag;
};

// 解决同一毫秒发起多个请求的情况
let lm_s_ts_suffix = 0;
export const requestInterceptor = (config) => {
  // 测试环境可以通过API_REQUEST_SIGN屏蔽接口签名
  if (window.ISONLINE === false) {
    const API_REQUEST_SIGN = window.localStorage && window.localStorage.getItem('API_REQUEST_SIGN');
    // 上游已经签名时仍需重签，保证 body 补值后签名与实际参数一致。
    if (JSON.parse(API_REQUEST_SIGN) === false && !(config.headers && config.headers['lm-s-sign'])) {
      return config;
    }
  }

  let path = config.url;
  if (path.indexOf('/') !== 0) {
    if (path.indexOf('http') === 0) {
      const url = new URL(path);
      path = url.pathname;
    } else if (path.indexOf('.') > -1) {
      path = `http://${path}`;
      const url = new URL(path);
      path = url.pathname;
    } else {
      path = `/${path}`;
    }
  } else if (path.indexOf('//') === 0) {
    path = `http:${path}`;
    const url = new URL(path);
    path = url.pathname;
  }

  // 业务代码可以通过将lm_s_ver置为0跳过签名逻辑。
  let lmSVer = 0;
  if (config.method.toLowerCase() === 'post') {
    if (config.data && Object.hasOwnProperty.call(config.data, 'lm_s_ver')) {
      lmSVer = config.data.lm_s_ver;
    } else if (isFormBody(config.data)) {
      lmSVer = config.data.get('lm_s_ver') || 0;
    } else if (typeof config.data === 'string') {
      // 上游已签名的字符串 body 在补值后仍需重签，避免保留旧签名。
      const jsonBody = readJsonBody(config.data);
      lmSVer = jsonBody ? jsonBody.lm_s_ver || 0 : new URLSearchParams(config.data).get('lm_s_ver') || 0;
    }
  } else if (config.method.toLowerCase() === 'get') {
    if (config.params && Object.hasOwnProperty.call(config.params, 'lm_s_ver')) {
      lmSVer = config.params.lm_s_ver;
    }
  }

  if (!needApiSign(path) && lmSVer == 0) {
    return config;
  }

  if (config.method.toLowerCase() === 'post') {
    // 将业务代码中transformRequest处理完的数据最后一位&去除，防止签名验证失败
    if (Array.isArray(config.transformRequest) && config.transformRequest.length > 0) {
      config.transformRequest.push(transformRequest);
    } else if (typeof config.transformRequest === 'function') {
      config.transformRequest = [config.transformRequest, transformRequest];
    }
  }

  // 每次签名时更新时间戳
  lm_s_ts_suffix += 1;
  const lm_s_ts = `${new Date().getTime()}${lm_s_ts_suffix}`; // 请求时间戳毫秒
  const lm_s_str = md5(lm_s_ts); // 请求的唯一串
  // 签名必传参数
  const requiredParams = {
    lm_s_id,
    lm_s_ts,
    lm_s_str,
    lm_s_ver: 1, // 是否开启接口签名
    h5: 1 // H5调用必传 1
  };

  // 获取签名参数
  const signParams = getSignParams(requiredParams, config);

  let signStr = '';
  if (config.requestSign && typeof config.requestSign === 'function') { // 支持自定义签名方法
    signStr = config.requestSign(signParams, config);
  } else {
    signStr = requestSign(signParams);
  }
  config.headers['lm-s-sign'] = signStr;

  return config;
};
